module.exports = __webpack_public_path__ + "files/9a6170450ee9493fd77f9f0dd2798f49.png";